angular.module("admin")


	.factory("AdminLicencesService", ["$resource", "$http", "SharedProperties", "CONSTANTS", "ENV", function ($resource, $http, SharedProperties, CONSTANTS, ENV) {
		return {

			getVerifyNameDevice: function (deviceName, selectedModule) {
				return $http.get(ENV.API_URL + "/licence/devices",
					{
						params: {
							"productId": selectedModule,
							"deviceName": deviceName
						}
					});
			},

			deleteQrCode: function (numLicence) {
				return $http.get(ENV.API_URL + "/licence/deleteQRCode",
					{
						params: {
							"token": SharedProperties.getApiToken(),
							"numLicence": numLicence,
						}
					});
			},

			postDelier: function (numLicence, motif) {
				var xdata = $.param({
					"token": SharedProperties.getApiToken(),
					"numLicence": numLicence,
					"motif": motif
				});
				return $http(
					{
						url: ENV.API_URL + "/licence/delierAppareil",
						method: "POST",
						data: xdata,
						headers: {"Content-Type": "application/x-www-form-urlencoded"}
					});
			},

			/**
			 * Ajouter une licence pour un appareil.
			 * @param productId
			 * @param deviceName
			 * @returns {*}
			 */
			postLicence: function (productId, deviceId) {
				var xdata = $.param({
					"productId": productId,
					"deviceId": deviceId
				});
				return $http(
					{
						url: ENV.API_URL + "/licence",
						method: "POST",
						data: xdata,
						headers: {
							"Content-Type": "application/x-www-form-urlencoded"
						}
					});
			},

			getMobileLicenceByClientInDevice: function (clientId, deviceId) {
				return $http.get(ENV.API_URL + "/licence/device/" + deviceId + "/client/" + clientId);
			},

			getDevicesByClient: function (clientId) {
				return $http.get(ENV.API_URL + "/devices/client/" + clientId);
			},

			getLicencesDeviceByClient: function () {
				return $http.get(ENV.API_URL + "/licence/devices");
			},

			getNbLicenceDispoByModule: function (moduleName) {
				return $http.get(ENV.API_URL + "/licence/nbLicenceDispoByModule",
					{
						params: {
							"moduleName": moduleName
						}
					});
			},

			getNbLicences: function (moduleName) {
				return $http.get(ENV.API_URL + "/licence/nbLicences");
			}

		};
	}
	]);